module.exports = __webpack_public_path__ + "img/矩形895@2x.e301b699.png";